import BaseItem, { Rarity } from './base_item';

export default class MedBed extends BaseItem {
    constructor(x, y) {
        super(x, y, "items", "medbed.png");
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 18;}
    static get height() { return 10;}

    static get mass() { return 4;}
    static get electronic() { return true; }
    static get rarity() { return Rarity.RARE; }


    static get type() { return 'medbed'}
    static get label() { return 'medical bed'}
    static get description() { return `Standard issue medical bed. Cures everything except from flu.`}
}


// WEBPACK FOOTER //
// ./src/objects/items/medbed.js